import { type SelectOption } from '@/components/Select/Select'

export const isSelectedSemesterInOptions = (
  semesterId: string,
  semesterList: SelectOption<string>[]
) => semesterList.find(semester => semester.value === semesterId)
